import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';
import { setSnackBar } from '../../states/app/staticSlice';

const fetcher = async (url) =>
  await AxiosConfig.create('get', url).call().getResponseData();

function useOrderDetails(orderId) {
  const dispatch = useDispatch();

  const { data, error, isLoading, mutate } = useSWR(
    orderId ? `/orders/${orderId}/details` : null,
    (url) => fetcher(url),
    {
      refreshInterval: import.meta.env.VITE_API_POLLING_INTERVAL,
      revalidateOnFocus: true,
    }
  );

  useEffect(() => {
    const errorStatus = error?.response?.status;
    const hasOrderDetails = Boolean(data?.data);

    // Evite les faux positifs pendant les revalidations SWR (304, erreurs transitoires)
    // quand on dispose deja de donnees en cache.
    if (errorStatus >= 400 && !hasOrderDetails) {
      const messageError = `Error: ${error?.response?.status} - ${error?.response?.statusText}: useOrderDetails`;
      dispatch(
        setSnackBar({ open: true, message: messageError, color: 'error' })
      );
    }
  }, [error, data, dispatch]);

  return {
    orderDetails: data?.data,
    res: {
      status: data?.code || error?.response?.status,
      statusText: data?.message || error?.response?.statusText,
    },
    isLoading,
    mutate: mutate,
  };
}

export default useOrderDetails;
